import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-bg",
  "use": "icon-play-bg-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-bg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM13.9096 22.1533L21.4619 17.6943C22.7127 16.9559 22.7127 15.0441 21.4619 14.3057L13.9096 9.8467C12.6939 9.12897 11.2 10.0632 11.2 11.5411V20.4589C11.2 21.9368 12.6939 22.871 13.9096 22.1533Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol